import {get} from 'aws-amplify/api';
import {Command, type GetMethod} from '../../Command';
import type {GetOneUserResponse} from '../../../dto/user/GetOneUserResponse';

export interface GetOneUserInput {
  id: string;
}

export class GetOneUserCommand extends Command<GetMethod, GetOneUserResponse> {
  constructor({id}: GetOneUserInput) {
    super(get, {
      path: `/user/${id}`,
      options: {
        withCredentials: false,
      },
    });
  }

  async deserialize(output: ReturnType<typeof get>): Promise<GetOneUserResponse> {
    const {body} = await output.response;
    return await (body.json() as unknown as Promise<GetOneUserResponse>);
  }
}
